// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ApplicationIconCell component should render without throwing an error 1`] = `
<div
  onClick={[Function]}
  onMouseEnter={[Function]}
  onMouseLeave={[Function]}
>
  <Upload
    accept="image/jpg,image/png"
    multiple={false}
    name="applicationIcon"
    noDrag={true}
    onDrop={[Function]}
    showThumbnails={false}
  >
    <Tooltip
      mouseEnterDelay={3000}
      placement="top-center"
      title="Upload App Icon"
    >
      <ApplicationIcon
        name=""
        size={39}
        src="test/url.png"
        style={
          {
            "cursor": "pointer",
          }
        }
      />
    </Tooltip>
  </Upload>
</div>
`;
